'use strict';

import { v4 } from "uuid";

export default class Utils {
  constructor(state) {
    this.state = state;
    this.debounced = {};
  }
  getComponentId(component) {
    if (!component) return `unknown-component-${v4()}`;
    if (typeof (component) === "string") {
      return `${component.toLowerCase()}-${v4()}`
    } else {
      return `${component.$options?.name?.toLowerCase()}-${v4()}`;
    }
  }
  getIsoDate(date) {
    if (!date || typeof (date) !== "object") return "";
    return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}`
  }
  getIsoDateTime(date) {
    if (!date || typeof (date) !== "object") return "";
    return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}T${this.twoDigits(date.getHours())}:${this.twoDigits(date.getMinutes())}:${this.twoDigits(date.getSeconds())}${this.offsetToTimeZone(date.getTimezoneOffset())}`;
  }
  twoDigits(x) {
    let sign = x < 0 ? "-" : "";
    x = Math.abs(x);
    if (x < 10) return `${sign}0${x}`;
    else return `${sign}${x}`;
  }
  showStatusMessage(msg, color, duration) {
    if (!msg) return;
    color = color || "green";
    duration = duration | 5000;
    let messageBox = document.createElement("div");
    messageBox.classList.add("cla-messagebox");
    messageBox.classList.add(color);
    messageBox.innerHTML = msg;
    document.body.appendChild(messageBox);
    setTimeout(() => {
      if (messageBox) {
        messageBox.style.opacity = '0';
        setTimeout(() => {
          messageBox.remove();
        }, 500);
      }
    }, duration);
  }
  offsetToTimeZone(offset) {
    if (offset === "0") return "Z";
    let intOffset = -parseInt(offset);
    return `${intOffset > 0 ? "+" : ""}${this.twoDigits(Math.floor(intOffset / 60))}:${this.twoDigits(intOffset % 60)}`;
  }
  showLoader(element, showAtTheTop) {
    let el = typeof (element) === "string" ? document.querySelector(element) : element;
    if (!el) {
      console.warn(`Could not create loader in the element ${typeof (element) === "string" ? element : element.name}`);
      return;
    }
    let loader = document.createElement("div");
    loader.classList.add("loader");
    if (showAtTheTop) loader.classList.add("top");
    el.appendChild(loader);
    return loader;
  }
  removeLoader(loader) {
    if (!loader) return;
    if (!loader.parentNode) return;
    loader.parentNode.removeChild(loader);
  }
  debounce(label, fnc, delay) {
    if (this.debounced.hasOwnProperty(label)) {
      clearTimeout(this.debounced[label]);
    }
    this.debounced[label] = setTimeout(fnc, delay);
  }
  getPageProperty(elId) {
    if (!elId) return "";
    const el = document.getElementById(elId);
    if (el) return el.value;
    else return "";
  }
  getCookie(name) {
    //var regexp = new RegExp("(?:^" + name + "|;\s*" + name + ")=(.*?)(?:;|$)", "g");
    var regexp = new RegExp(`.*${name}=(.*?)(?:;|$)`, "gi");
    var result = regexp.exec(document.cookie);
    return (result === null) ? "" : result[1];
  }
  areEqualIds(id1, id2) {
    id1 = this.toShortId(id1);
    id2 = this.toShortId(id2);
    return id1 === id2;
  }
  containsId(text, id) {
    if (!text) {
      console.log("Text is empty");
      return false;
    }
    let ret = text.split("|").find(x => this.areEqualIds(x, id)) === id;
    return ret;
  }
  toShortId(id) {
    if (!id) return "";
    if (id.length !== 38) return id.toLowerCase();
    return id.replace(/[{}\-]/gi, "").toLowerCase();
  }
  toLongId(id) {
    if (!id) return "";
    if (id.length !== 32) return id.toUpperCase();
    return `{${id.substring(0, 8)}-${id.substring(8, 12)}-${id.substring(12, 16)}-${id.substring(16, 20)}-${id.substring(20)}}`.toUpperCase();
  }
  isEmail(email) {
    if (!email) return false;
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  idsToLabels(ids) {
    if (!ids) return "";
    const taxonomyMap = this.state.get("taxonomy");
    let labels = [];
    let idArray = ids.split("|");
    idArray.map(id => {
      if (taxonomyMap.hasOwnProperty(id)) labels.push(taxonomyMap[id]);
    });
    if (labels.length === 0) return "";
    else return labels.join("|");
  }
  isNewsPage() {
    var regex = /^https?:\/\/.+(\/.+)?\/corporate\/news.*$/gi;
    return regex.test(window.location.href);
  }
  isCareersPage() {
    var regex = /^https?:\/\/.+(\/.+)?\/careers.*$/gi;
    return regex.test(window.location.href);
  }
  isInvestorsPage() {
    var regex = /^https?:\/\/.+(\/.+)?\/investors.*$/gi;
    return regex.test(window.location.href);
  }
  contactBelongsToBU(buId, contact) {
    if (!buId) return false;
    if (!contact) return false;

    let bu = this.state.bu || contact.buGuids;

    if (bu) {
      return bu.indexOf(buId) !== -1;
    } else {
      //if we got here, it means that the state and the contact do not have an explicit BU
      //so we look at the parent of the BL, if one is specified
      let bl = this.state.bl || contact.blGuids;
      if (!bl) return false;
      let belogs = false;
      let self = this;
      let blParents = this.state.get("blParents");
      if (!blParents) return false;
      bl.split("|").map(l => {
        if (l && blParents.hasOwnProperty(l) && blParents[l] === buId) {
          belogs = true;
        }
      });
      return belogs;
    }
  }
};
